module.exports = __webpack_public_path__ + "img/cockroachdb-client.8b688bf1.svg";